/**
 * Footer del shell autenticado.
 *
 * Sprint 11 v2 S11-V2-03 → Sprint 14 S14-13. Simplificado: los 3 links
 * (Ayuda, Datos para transferir, Cerrar sesión) migraron al `UserMenu`
 * que cuelga del avatar del Header. El Footer queda como marca + nota
 * de portal privado para el cierre visual del card del shell.
 *
 * Sprint 16 S16-09: agrega `<FooterVersion />` que muestra la versión
 * del módulo activo (Portal / Tesorería / Comisión según pathname).
 */
import { FooterVersion } from './FooterVersion';

export function Footer() {
  return (
    <footer className="bg-bg-page px-4 md:px-8 py-5 text-sm text-text-primary">
      <div className="flex items-center justify-between gap-4 flex-wrap">
        <div className="flex items-center gap-2 flex-wrap">
          <span className="text-orange font-medium">Barrio</span>
          <span className="text-text-primary font-medium tracking-wider">
            CALBUCURA
          </span>
          <span className="opacity-60 ml-2">· Portal privado</span>
        </div>
        <FooterVersion />
      </div>
    </footer>
  );
}
